export default {
    controller: 'editReservationController',
    template: require('../views/editReservation.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/components/editReservation.component.js